export const environment = {
    production: true,
    LAUNCHDARKLY_CLIENT_ID: '6177d25d8ea2a2258182d2e5',
    API_URL: 'https://pg.test.ridango.com',
    TPS_AUTH_URL: 'https://auth.pg.test.sfey.com',
    OAUTH_CLIENT_ID: 'PGTestNewAdminUI',
};
